import { Link } from 'react-router-dom';

interface RegentsTestCardProps {
  testNumber: number;
  title: string;
  description: string;
  gradient: string;
  bgColor: string;
  borderColor: string;
  route: string;
}

export default function RegentsTestCard({
  testNumber,
  title,
  description,
  gradient,
  bgColor,
  borderColor,
  route,
}: RegentsTestCardProps) {
  return (
    <div className={`bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border-2 ${borderColor} overflow-hidden group`}>
      <div className={`bg-gradient-to-r ${gradient} p-6 text-white`}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <i className="ri-file-list-3-line text-2xl"></i>
            </div>
            <div>
              <p className="text-white/80 text-xs font-medium uppercase tracking-wide">Practice Test</p>
              <p className="text-2xl font-black">{title}</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-3xl font-black">86</p>
            <p className="text-white/80 text-xs">points</p>
          </div>
        </div>
        <p className="text-white/80 text-sm">{description}</p>
      </div>
      <div className="p-6">
        <div className="flex items-center gap-4 mb-5 text-sm text-gray-500 flex-wrap">
          <div className="flex items-center gap-1">
            <i className="ri-question-line text-emerald-500"></i>
            <span>35 questions</span>
          </div>
          <div className="flex items-center gap-1">
            <i className="ri-time-line text-emerald-500"></i>
            <span>~3 hours</span>
          </div>
          <div className="flex items-center gap-1">
            <i className="ri-award-line text-amber-500"></i>
            <span>86 pts</span>
          </div>
        </div>
        <Link
          to={route}
          className={`w-full py-3 bg-gradient-to-r ${gradient} text-white rounded-xl font-bold text-sm hover:opacity-90 transition-opacity shadow-md whitespace-nowrap flex items-center justify-center`}
        >
          <i className="ri-play-circle-fill mr-2"></i>
          Start Test {testNumber}
        </Link>
      </div>
    </div>
  );
}